module.exports = __webpack_public_path__ + "img/ics_o_download_png.03bcddba.svg";